import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import '../../../component-styles/AnimatedDropdown.css';

export default function AnimatedDropdown({ options, value, onChange, placeholder = 'Select…' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  // Close when clicking outside
  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    window.addEventListener('mousedown', handleClick);
    return () => window.removeEventListener('mousedown', handleClick);
  }, []);

  const toggle = () => setOpen((o) => !o);

  return (
    <div className="animated-dd" ref={ref}>
      <button
        type="button"
        className={`animated-dd-trigger ${open ? 'open' : ''}`}
        onClick={toggle}
      >
        <span>{options.find((o) => o.value === value)?.label || placeholder}</span>

        <ChevronDown size={18} className={`animated-dd-arrow ${open ? 'rotated' : ''}`} />
      </button>

      <div className={`animated-dd-menu ${open ? 'show' : ''}`}>
        {options.map((opt, i) => (
          <div
            className="animated-dd-item"
            key={opt.value}
            style={{ animationDelay: `${i * 0.04}s` }} // cascade stagger
            onClick={() => {
              onChange(opt.value);
              setOpen(false);
            }}
          >
            {opt.label}
          </div>
        ))}
      </div>
    </div>
  );
}
